// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "../static/iconfont.css"
import VueWechatTitle from 'vue-wechat-title'
// video配置
import VideoPlayer from 'vue-video-player'

// 引入方式一
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import App from './App'
import router from './router'
import axios from 'axios'
import Base64 from 'js-base64'
import {
  setCookie,
  getCookie,
  delCookie
} from '@/utils/auth.js'

import Swiper from 'swiper'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

// 当路由进入前
router.beforeEach((to, from, next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();
  // 这个一定要加，没有next()页面不会跳转的
  next();
});

// 当路由进入后：关闭进度条
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

Vue.use(VideoPlayer)

Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}

Vue.use(VueWechatTitle)
Vue.use(ElementUI)
Vue.use(Base64)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

axios.interceptors.response.use(function(response) {
  // 对响应数据做点什么
  if (response.data.code == 403) {
    location.href = '/#/login'
    return;
  }
  return response;
}, function(error) {
  // 500 清除所有缓存
  delCookie('token')
  delCookie('userInfo')
  location.href = '/#/login'
  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  Swiper,
  ElementUI,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js